// serviceTypeMapping.js (or inside your component/utils file)
export const SERVICE_TYPE_MAPPING = {
  // Grooming category
  "Grooming Salon": "grooming",

  // Day Care category
  "Day Care Services": "day_care",

  // Vet Clinic category
  "Pet Vet Clinic": "vet_clinic",

  // Boarding categories (both sub-types map to the same backend value)
  "Kennel Boarding": "boarding",
  "Pet Resort": "boarding",

  // If you ever get "Pet Shop" or others, add them here
  // "Pet Shop": "pet_store", // but backend doesn't support yet
};
export const getBackendServiceType = (serviceTypeName) => {
  if (!serviceTypeName) return null;
  
  const backendType = SERVICE_TYPE_MAPPING[serviceTypeName];
  
  if (!backendType) {
    console.warn(`No backend mapping for: "${serviceTypeName}"`);
    return null;
  }
  
  return backendType;
};

const HIDDEN_VENDOR_SERVICE_LABELS = new Set([
  "day care",
  "day care services",
  "pet shop",
]);

export const isHiddenVendorService = (label) => {
  if (!label || typeof label !== "string") return false;
  return HIDDEN_VENDOR_SERVICE_LABELS.has(label.trim().toLowerCase());
};

export const filterVisibleVendorServices = (services = []) => {
  if (!Array.isArray(services)) return [];

  return services.filter(
    (service) => !isHiddenVendorService(service?.service_type_name)
  );
};
